module.exports = "/_next/static/images/bs-524a1ab504dea5506aa332eb7dea4f61.svg";